import styles from "./Loader.module.css";
import cx from "classnames";
import { CSSProperties } from "react";

const LOADING_TEXT = "Loading...";

export type Size = "small" | "medium" | "large";
export default function Loader({
  color = "black",
  className,
  size = "large",
  centered = true,
  style,
}: {
  className?: string;
  color?: "black" | "white";
  size?: Size;
  centered?: boolean;
  style?: CSSProperties;
}) {
  return (
    <>
      <div
        className={cx(styles.root, className, {
          [styles.white]: color === "white",
          "w-6 h-6": size === "small",
          "w-8 h-8": size === "medium",
          "w-12 h-12": size === "large",
          [styles.centered]: centered,
        })}
        style={style}
      >
        <svg viewBox="25 25 50 50">
          <circle cx="50" cy="50" r="20" />
        </svg>
      </div>
      <div className="sr-only">{LOADING_TEXT}</div>
    </>
  );
}
